import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Lock } from 'lucide-react';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 rounded-full border border-white/10 mb-6">
              <Lock className="w-4 h-4 text-emerald-400" />
              <span className="text-white/60 text-sm">Legal</span>
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-white" data-testid="privacy-heading">Privacy Policy</h1>
            <p className="text-white/40 text-sm mt-4">Last updated: January 2025</p>
          </div>

          <div className="space-y-8" data-testid="privacy-content">
            <Section title="Introduction">
              Frontier Investments ("we", "our", "us") is committed to protecting the privacy and confidentiality of the personal information of our clients, prospective clients and visitors to our website. This Privacy Policy explains how we collect, use, store and protect your information when you interact with our website and services.
            </Section>

            <Section title="Information We Collect">
              We may collect the following types of information: your name, email address, phone number and other contact details provided through our contact forms or portfolio upload feature; financial information you voluntarily share for the purpose of receiving mutual fund distribution services; technical information such as browser type, IP address and website usage data collected through standard web technologies; and any documents or files you upload through our Portfolio Review service.
            </Section>

            <Section title="How We Use Your Information">
              The information we collect is used to provide and improve our mutual fund distribution services; respond to your enquiries and communicate with you; analyse and review portfolios submitted through our Portfolio Review feature; comply with legal and regulatory obligations as mandated by SEBI, AMFI and other regulatory bodies; and send relevant updates about our services, only with your consent.
            </Section>

            <Section title="Data Protection and Security">
              We implement appropriate technical and organisational measures to safeguard your personal and financial data against unauthorised access, alteration, disclosure or destruction. All documents uploaded through our website are stored securely and are accessible only to authorised members of our team. We do not sell, rent or trade your personal information to any third party.
            </Section>

            <Section title="Third-Party Sharing">
              We do not share your personal information with third parties except where required by law or regulatory authorities; with your explicit consent; or with trusted service providers who assist in operating our website and services, subject to strict confidentiality agreements.
            </Section>

            <Section title="Cookies and Tracking">
              Our website may use cookies and similar technologies to enhance your browsing experience and analyse website traffic. You may choose to disable cookies through your browser settings, though this may affect certain functionalities of the website.
            </Section>

            <Section title="Your Rights">
              You have the right to access, correct or request deletion of your personal information held by us. You may withdraw consent for marketing communications at any time. To exercise any of these rights, please contact us at contact@frontierinvestments.co.
            </Section>

            <Section title="Changes to This Policy">
              We may update this Privacy Policy from time to time to reflect changes in our practices or applicable regulations. Any changes will be posted on this page with an updated revision date.
            </Section>

            <Section title="Contact Us">
              If you have any questions or concerns regarding this Privacy Policy, please contact us at contact@frontierinvestments.co or call us at +91 93532 80305.
            </Section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="bg-white/5 rounded-2xl border border-white/10 p-6 lg:p-8">
      <h2 className="text-lg font-bold text-white mb-3">{title}</h2>
      <p className="text-white/60 text-sm leading-relaxed">{children}</p>
    </div>
  );
}
